var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKlaytn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.182 3.56588C17.2725 1.95475 14.9453 1.05967 12.4391 1L6.77033 15.8582L19.182 3.56588ZM20.6141 4.93833L13.4535 12.0393L20.6141 19.0805C22.285 17.1113 23.18 14.6051 23.18 12.0393C23.18 9.4137 22.285 6.96716 20.6141 4.93833ZM9.63457 2.67081L0.922506 11.3232C0.743491 14.1278 1.63857 16.813 3.42871 19.0208L9.63457 2.67081ZM12.0811 13.4117L4.92051 20.453C6.94934 22.1238 9.45555 23.0188 12.0811 23.0188C14.7067 23.0188 17.2129 22.1238 19.2417 20.453L12.0811 13.4117Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlaytn);
export default __webpack_public_path__ + "static/media/klaytn.bf60d1616febf85e57a94846e3717638.svg";
export { ForwardRef as ReactComponent };